import NextImage from 'next/image';

import React from 'react';
import Balancer from 'react-wrap-balancer';

import styled from 'styled-components';

import ScrollReveal from '@components/common/ScrollReveal';
import { Container } from '@components/parts/Container';

import { UploadedImage } from '@customTypes/UploadedImage';

type Props = {
  image: UploadedImage;
  description?: string;
};

const Wrapper = styled.div`
  .image {
    width: 100%;
    aspect-ratio: 16/9;
    position: relative;
    img {
      aspect-ratio: 16/9;
      width: 100%;
    }
  }

  p {
    text-align: center;
    margin-top: 50px;
    margin-bottom: 90px;
    font-size: 26px;
    font-weight: 700;
    padding: 0 8px;
    white-space: pre-wrap;
    @media (min-width: 768px) {
      margin-top: 90px;
      margin-bottom: 160px;
      font-size: 32px;
    }
  }
`;

export const Image: React.FC<Props> = (props) => {
  const { image, description } = props;
  return (
    <>
      <Container fullOnMobile={true}>
        <Wrapper>
          <ScrollReveal>
            <div className="image">
              {image?.data?.attributes?.url ? (
                <NextImage fill src={image.data.attributes.url} alt={description || 'Image'} />
              ) : null}
            </div>
          </ScrollReveal>
        </Wrapper>
      </Container>
      <Container>
        <Wrapper>
          {description ? (
            <ScrollReveal>
              <p>
                <Balancer>{description}</Balancer>
              </p>
            </ScrollReveal>
          ) : null}
        </Wrapper>
      </Container>
    </>
  );
};
